import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {Observable, finalize, tap} from 'rxjs';
import { AgreementView } from 'src/app/admin/data-access/agreement.model';
import { AgreementService } from 'src/app/admin/data-access/agreement.service';

@Component({
    selector: 'loginTerms',
    templateUrl: './loginTerms.html',
    standalone: false
})
export class LoginTermsComponent {
  requiredAgreement$: Observable<AgreementView> =
    this.agreementService.nextRequiredAgreement$.pipe(
      tap((agreement) => {
        if (!agreement) {
          this.router.navigate(['dashboard']);
        }
      }),
      finalize(() => this.router.navigate(['dashboard']))
    );

  constructor(
    private router: Router,
    private agreementService: AgreementService
  ) {}

  checkForHTMLTags(test?: string): boolean {
    if(test != null)
      return /<\/?[a-z][\s\S]*>/i.test(test)
    else
      return false
  }

  onAcceptClick(agreement_id: string) {
    this.agreementService.acceptRequiredAgreement(agreement_id);
  }
}
